import { render, staticRenderFns } from "./addPlugins.vue?vue&type=template&id=481bf226&scoped=true"
import script from "./addPlugins.vue?vue&type=script&lang=js"
export * from "./addPlugins.vue?vue&type=script&lang=js"
import style0 from "./addPlugins.vue?vue&type=style&index=0&id=481bf226&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bf226",
  null
  
)

export default component.exports